import Svg from 'react-native-svg';

const ColumnSortingIcon = () => {
  return (
    <Svg fill="none" height={14} width={11} viewBox="0 0 11 14">
      <path
        stroke="#0D0D0D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="m1.61 5 4-4 4 4M1.61 9l4 4 4-4"
      />
    </Svg>
  );
};

export default ColumnSortingIcon;
